<template>
  <v-select
    v-model="selected"
    :items="items"
    item-value="id"
    item-text="formattedName"
    :loading="isLoading"
    :multiple="multiple"
    :clearable="clearable"
    :chips="multiple"
    :disabled="disabled || isLoading"
    chips
    small-chips
    outlined
    dense
    menu-props="auto, overflowX, overflowY"
    label="Default Tax Rates"
    @change="$emit('select-item', selected)"
  />

<!--  <v-select-->
<!--    v-model="selected"-->
<!--    :items="allDivisions"-->
<!--    item-value="id"-->
<!--    item-text="label"-->
<!--    outlined-->
<!--    dense-->
<!--    :clearable="clearable"-->
<!--    :chips="multiple"-->
<!--    :label="getLabel()"-->
<!--    :multiple="multiple"-->
<!--    :prepend-icon="prependIcon"-->
<!--    :disabled="disabled"-->
<!--    menu-props="auto, overflowX, overflowY"-->
<!--    @change="$emit('select-item', selected)"-->
<!--  />-->

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    initTaxRate: {
      type: String,
      default: ''
    },
    initTaxRates: {
      type: Array,
      default: () => []
    },
    clearable: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    prependIcon: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selected: null,
      isLoading: false
    }
  },
  computed: {
    ...mapGetters([ 'getTaxRates' ]),
    items() {
      return this.getTaxRates
        .filter(rate => rate.active)
        .map(rate => {
          const incl = rate.inclusive ? ' incl.' : ''
          rate.formattedName = `${rate.display_name} - ${rate.jurisdiction} (${rate.percentage}%${incl})`
          return rate
        })
    }
  },
  // watch: {
  //   initTaxRate() {
  //     this.init()
  //   },
  //   initTaxRates() {
  //     console.log('init tax rate changes')
  //     this.init()
  //   }
  // },
  created() {
    this.isLoading = true
    this.listTaxRates({})
      .then(res => {
        this.init()
      })
      .finally(() => {
        this.isLoading = false
      })
  },
  methods: {
    ...mapActions(['listTaxRates']),
    getLabel() {
      if (this.disabled) {
        return ''
      } else {
        return `Select ${this.multiple ? this.$t('common.tax_rates.plural') : this.$t('common.tax_rates.singular') }`
      }
    },
    init() {
      this.selected = this.multiple
        ? (this.initTaxRates || [])
        : (this.initTaxRate || '')
    }
  }
}
</script>
